import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountFormFields implements ZIDXPage {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxAccountFormFieldsContainer";
    }


    render() {
        let table=this.zidx.peakidxShadowRoot.querySelector(".zidxAccountFormFieldsContainer .zidxRecordSort")!;
        this.zidx.setupRecordSort(table, function(result:any){});
    }
}